module.exports = __webpack_public_path__ + "img/20220219_130619.40248593.jpg";